<template>
  <b-row class="justify-content-center">
    <b-col md="8">
      <div class="form-card">
        <!-- Section Header -->
        <h2 class="form-title">New Automation</h2>
        <p class="form-subtitle">Configure your automation with ease</p>

        <b-form @submit.prevent="submitAutomation">
          <!-- Name Input -->
          <b-form-group label="Name" label-for="name" class="form-group">
            <b-form-input
              id="name"
              v-model="form.name"
              required
              placeholder="Enter automation name"
              class="form-input"
            ></b-form-input>
          </b-form-group>

          <!-- Access Token Input -->
          <b-form-group
            label="Access Token"
            label-for="accessToken"
            class="form-group"
          >
            <b-form-input
              id="accessToken"
              v-model="form.accessToken"
              required
              placeholder="Enter access token"
              class="form-input"
            ></b-form-input>
          </b-form-group>

          <b-row v-if="user.allowCustomProxy">
            <b-col md="3">
              <span>Use custom proxy ? </span>
            </b-col>
            <b-col
              ><b-form-checkbox
                id="ipv4"
                v-model="form.useCustomProxy"
                name="ipv4"
              >
              </b-form-checkbox>
            </b-col>
          </b-row>

          <!-- Proxy Details Section -->
          <template v-if="form.useCustomProxy">
            <div class="proxy-section">
              <h6 class="section-title">Proxy Details</h6>
              <b-row>
                <b-col md="6">
                  <b-form-group label="Username" label-for="proxyUsername">
                    <b-form-input
                      id="proxyUsername"
                      v-model="form.proxyUsername"
                      placeholder="Enter username"
                      class="form-input"
                    ></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group label="Password" label-for="proxyPassword">
                    <b-form-input
                      id="proxyPassword"
                      v-model="form.proxyPassword"
                      type="password"
                      placeholder="Enter password"
                      class="form-input"
                    ></b-form-input>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="6">
                  <b-form-group label="Host" label-for="host">
                    <b-form-input
                      id="host"
                      v-model="form.host"
                      placeholder="Enter host"
                      class="form-input"
                    ></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group label="Port" label-for="port">
                    <b-form-input
                      id="port"
                      v-model="form.port"
                      placeholder="Enter port"
                      class="form-input"
                    ></b-form-input>
                  </b-form-group>
                </b-col>
              </b-row>
              <!-- <b-row>
                  <b-col md="3">
                    <span>Is this proxy and IPv4 ? </span>
                  </b-col>
                  <b-col
                    ><b-form-checkbox id="ipv4" v-model="form.isIPV4" name="ipv4">
                    </b-form-checkbox>
                  </b-col>
              </b-row> -->
            </div>
          </template>

          <!-- Get Pages Button -->
          <b-button
            type="button"
            @click="fetchPages"
            variant="primary"
            class="w-100 mt-4 action-btn"
          >
            Get Pages
          </b-button>

          <!-- Loading Spinner -->
          <div v-if="loadingPages" class="text-center my-4">
            <b-spinner style="width: 3rem; height: 3rem"></b-spinner>
          </div>

          <!-- Dynamic Fields -->
          <template v-if="pageOptions.length">
            <b-row class="mt-3">
              <b-col md="12">
                <b-form-group
                  label="Post Type"
                  label-for="postType"
                  class="form-group"
                >
                  <b-form-select
                    id="postType"
                    v-model="form.postType"
                    :options="postTypeOptions"
                    class="form-select"
                    required
                  ></b-form-select>
                </b-form-group>
              </b-col>
              <template v-if="permissions.allowCollaborations">
                <b-col md="6">
                  <b-form-group
                    label="Collab Name"
                    label-for="collabName"
                    class="form-group"
                  >
                    <b-form-input
                      id="collabName"
                      v-model="form.collabName"
                      placeholder="Enter collab name"
                      class="form-input"
                    ></b-form-input>
                  </b-form-group>
                </b-col>

                <b-col md="6">
                  <b-form-group
                    label="Collab ID"
                    label-for="collabId"
                    class="form-group"
                  >
                    <b-form-input
                      id="collabId"
                      v-model="form.collabId"
                      placeholder="Enter collab ID"
                      class="form-input"
                    ></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col md="12">
                  <b-form-group
                    label="Hashtag Pool"
                    label-for="hashtagPool"
                    class="form-group"
                  >
                    <b-form-textarea
                      id="hashtagPool"
                      v-model="form.hashtagPool"
                      rows="3"
                    ></b-form-textarea>
                  </b-form-group>
                </b-col>
              </template>
            </b-row>

            <b-form-group label="Page" label-for="pageId" class="form-group">
              <b-form-select
                id="pageId"
                v-model="form.pageId"
                :options="pageOptions"
                @change="updatePageDetails"
                class="form-select"
              ></b-form-select>
            </b-form-group>

            <b-row>
              <b-col md="6">
                <b-form-group
                  label="Interval Min (minutes)"
                  label-for="intervalMin"
                  class="form-group"
                >
                  <b-form-input
                    id="intervalMin"
                    type="number"
                    required
                    v-model="form.intervalMin"
                    placeholder="Enter interval"
                    class="form-input"
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group
                  label="Interval Max (minutes)"
                  label-for="intervalMax"
                  class="form-group"
                >
                  <b-form-input
                    id="intervalMax"
                    type="number"
                    required
                    v-model="form.intervalMax"
                    placeholder="Enter interval"
                    class="form-input"
                    :min="form.intervalMin"
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group
                  label="Use File Name as Description"
                  label-for="fileNameAsDescription"
                  class="form-group mt-4"
                >
                  <b-form-select
                    id="fileNameAsDescription"
                    v-model="form.fileNameAsDescription"
                    :options="[
                      { value: true, text: 'Yes' },
                      { value: false, text: 'No' },
                    ]"
                    class="form-select"
                  >
                  </b-form-select>
                </b-form-group>
              </b-col>
              <b-col
                md="6"
                v-if="form.postType === 1 && permissions.allowStoryPost"
              >
                <div style="margin: auto">
                  <span>Post as Story</span>
                  <b-form-checkbox id="ipv4" v-model="form.isStory" name="ipv4">
                  </b-form-checkbox>
                </div>
              </b-col>
            </b-row>
            <b-form-group
              label="Compressed Folder"
              label-for="file"
              class="form-group"
            >
              <vue-dropzone
                id="customdropzone"
                ref="dropzone"
                :options="dropzoneOptions"
                @vdropzone-file-added="handleFileAdded"
                @vdropzone-removed-file="handleFileRemoved"
                class="custom-dropzone"
              >
                <div class="dropzone-custom-content">
                  <h3 class="dropzone-custom-title">
                    Drag and drop your media here
                  </h3>
                  <div class="subtitle">or click to select file</div>
                </div>
              </vue-dropzone>
            </b-form-group>

            <!-- Progress Bar -->
            <b-progress
              v-if="uploadProgress > 0"
              :value="uploadProgress"
              show-value
              class="mt-3"
              height="2rem"
              animated
            ></b-progress>

            <!-- Submit Button -->
            <b-button
              type="submit"
              variant="success"
              class="w-100 mt-4 submit-btn"
              :disabled="submitting"
            >
              <b-spinner small v-if="submitting" class="mr-2"></b-spinner>
              {{ submitting ? "Submitting..." : "Submit" }}
            </b-button>
          </template>
          <template v-else-if="retryCount > 0 && !loadingPages">
            <h5 class="text-center pt-5">No Pages Found</h5>
          </template>
        </b-form>
      </div>
    </b-col>
  </b-row>
</template>

<style scoped>
/* General Styling */
.form-container {
  background-color: #f9fafb;
  padding: 40px;
  border-radius: 12px;
}

.form-card {
  background: white;
  border-radius: 16px;
  padding: 30px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
}

/* Typography */
.form-title {
  font-size: 22px;
  font-weight: 600;
  color: #111827;
}

.form-subtitle {
  font-size: 14px;
  color: #6b7280;
  margin-bottom: 20px;
}

/* Input Fields */
.form-group {
  margin-bottom: 20px;
}

.form-input,
.form-select,
.form-file {
  width: 100%;
  border-radius: 8px;
  border: 1px solid #d1d5db;
  padding: 10px;
  font-size: 14px;
  background-color: white;
  transition: border 0.2s ease-in-out;
}

.form-input:focus,
.form-select:focus,
.form-file:focus {
  border-color: #0077ff;
  box-shadow: 0 0 4px rgba(99, 102, 241, 0.2);
}

/* Proxy Section */
.proxy-section {
  background: #f3f4f6;
  padding: 20px;
  border-radius: 8px;
  margin-top: 20px;
}

.section-title {
  font-size: 16px;
  font-weight: 600;
  color: #374151;
  margin-bottom: 10px;
}

/* Buttons */
.action-btn {
  background-color: #0077ff;
  color: white;
  font-size: 16px;
  padding: 12px;
  border-radius: 8px;
  transition: all 0.2s ease-in-out;
}

.action-btn:hover {
  background-color: #4f46e5;
}

.submit-btn {
  background-color: #22c55e;
  color: white;
  font-size: 16px;
  padding: 12px;
  border-radius: 8px;
  transition: all 0.2s ease-in-out;
}

.submit-btn:hover {
  background-color: #16a34a;
}

/* Dropzone Styling */
.custom-dropzone {
  border: 2px dashed #d1d5db !important;
  border-radius: 8px !important;
  background: #f9fafb !important;
  min-height: 150px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  cursor: pointer;
  transition: all 0.3s ease;
}

.custom-dropzone:hover {
  border-color: #0077ff !important;
  background: #f3f4f6 !important;
}

.dropzone-custom-content {
  text-align: center;
}

.dropzone-custom-title {
  font-size: 1.25rem;
  font-weight: 500;
  color: #374151;
  margin-bottom: 0.5rem;
}

.subtitle {
  color: #6b7280;
  font-size: 0.875rem;
}

.vue-dropzone > .dz-preview .dz-image {
  border-radius: 8px !important;
}

.vue-dropzone > .dz-preview {
  margin: 10px !important;
}

.vue-dropzone > .dz-preview .dz-remove {
  color: #ef4444 !important;
  text-decoration: none !important;
  font-weight: 500;
  margin-top: 8px;
}

.vue-dropzone > .dz-preview .dz-remove:hover {
  text-decoration: underline !important;
}

@media (max-width: 768px) {
  .form-container {
    padding: 20px;
  }
}
</style>

<script>
import router from "@/router";
import axios from "axios";
import vueDropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";

export default {
  components: {
    vueDropzone,
  },
  data() {
    return {
      form: {
        name: "",
        accessToken: "",
        pageId: "",
        proxyUsername: "",
        proxyPassword: "",
        host: "",
        port: "",
        intervalMin: "",
        intervalMax: "",
        pageName: "",
        postType: null,
        file: null,
        isIPV4: false,
        fileNameAsDescription: false,
        useCustomProxy: false,
        collabId: null,
        collabName: null,
        hashtagPool: null,
        isStory: false,
      },
      retryCount: 0,
      postTypeOptions: [],
      loadingPages: false,
      pageOptions: [],
      submitting: false,
      uploadProgress: 0,
      dropzoneOptions: {
        url: "dummy", // Required but not used since we handle the file manually
        thumbnailWidth: 150,
        maxFilesize: 10000, // MB
        addRemoveLinks: true,
        acceptedFiles: ".zip",
        autoProcessQueue: false,
        maxFiles: 1,
      },
    };
  },

  computed: {
    user() {
      return this.$store.state.user;
    },
    permissions() {
      return this.$store.state.user.permissions;
    },
  },

  methods: {
    async fetchPages() {
      const { accessToken, proxyUsername, proxyPassword, host, port } =
        this.form;
      this.retryCount += 1;

      if (!accessToken) {
        this.$toast.error("Fill in all fields");
        return;
      }
      try {
        if (this.permissions.allowReels) {
          this.postTypeOptions.push({ value: 1, text: "Reel" });
        }
        if (this.permissions.allowPhotos) {
          this.postTypeOptions.push({ value: 0, text: "Photo" });
        }
        this.loadingPages = true;
        const response = await axios.post("/api/get-pages", {
          accessToken: this.form.accessToken,
          isIPV4: this.form.isIPV4,
          proxyUsername: this.form.proxyUsername,
          proxyPassword: this.form.proxyPassword,
          host: this.form.host,
          port: this.form.port,
        });
        this.pageOptions = response.data.pages.map((page) => ({
          value: page.id,
          text: page.name,
        }));
        this.loadingPages = false;
      } catch {
        this.loadingPages = false;
        this.$toast.error("Failed to fetch pages");
      }
    },
    updatePageDetails() {
      const selectedPage = this.pageOptions.find(
        (page) => page.value === this.form.pageId
      );
      if (selectedPage) {
        this.form.pageName = selectedPage.text;
      }
    },
    async submitAutomation() {
      const formData = new FormData();
      this.submitting = true;
      this.uploadProgress = 0;
      for (const key in this.form) {
        formData.append(key, this.form[key]);
      }

      const url =
        this.form.postType === 1 ? "/schedule-reels" : "/schedule-posts";

      try {
        await axios.post(url, formData, {
          headers: { "Content-Type": "multipart/form-data" },
          onUploadProgress: (progressEvent) => {
            this.uploadProgress = Math.round(
              (progressEvent.loaded / progressEvent.total) * 100
            );
          },
        });
        this.$toast.success("Automation Created Successfully");
        setTimeout(() => {
          this.uploadProgress = 0;
          router.push("/dashboard");
        }, 1500);
      } catch {
        this.$toast.error("Failed to create automation");
      } finally {
        this.submitting = false;
        this.uploadProgress = 0;
      }
    },
    handleFileAdded(file) {
      this.form.file = file;
      console.log(this.form.file);
    },
    handleFileRemoved() {
      this.form.file = null;
    },
  },
};
</script>
